/***
 *
 *   APP NAV STYLES
 *   Ported from ui-reference/src/components/layouts/{sidebar,sidebar-nav-item,
 *   sidebar-workspace-switcher}.tsx.
 *
 *   The sidebar is `bg-primary` in BOTH themes — a deep indigo panel — so
 *   everything on it is styled against white rather than against the theme
 *   tokens. That is why the borders and hovers here are `white/10` and `white/5`
 *   rather than `border-border` / `bg-muted`.
 *
 **********/

const Style = {
    // In-flow left strip of the primary frame. Below md the mobile bottom
    // bar takes over entirely, so this stays `hidden` until the md breakpoint.
    sidebar: `hidden h-full shrink-0 flex-col bg-primary
    motion-safe:transition-[width] motion-safe:duration-200 motion-safe:ease-out md:flex`,
    expanded: 'w-60',
    collapsed: 'w-16',

    // -- top slot: organisation identity -----------------------------------
    top: 'flex h-16 shrink-0 items-center border-b border-white/10 px-1',

    orgRow: 'flex w-full items-center gap-2 rounded-md py-2 transition-colors',
    orgRowExpanded: 'px-2',
    orgRowCollapsed: 'justify-center px-0',
    orgRowInteractive: 'cursor-pointer hover:bg-white/10',
    orgName: 'min-w-0 flex-1 truncate text-left text-sm font-medium text-primary-foreground',
    orgChevron: 'shrink-0 text-accent-300',
    orgMark: 'border-white/25',
    orgMarkFallback: 'bg-white/15 text-white',
    orgSkeletonMark: 'h-8 w-8 shrink-0 animate-pulse rounded-full bg-white/10',
    orgSkeletonLabel: 'h-4 min-w-0 flex-1 animate-pulse rounded bg-white/10',

    // -- nav ---------------------------------------------------------------
    nav: 'mt-2 flex-1 space-y-1 overflow-y-auto px-2',

    item: `group flex w-full items-center gap-2.5 rounded-md px-2.5 py-2.5 text-sm
    transition-colors duration-150 ease-out
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40`,
    itemActive: 'bg-white/10 text-primary-foreground',
    itemIdle: 'text-accent-200/80 hover:bg-white/5 hover:text-primary-foreground',
    itemCollapsed: 'justify-center px-0',
    itemLabel: 'truncate',

    // The Tooltip wrapper is `inline-flex` by default, which would stop a
    // collapsed nav item filling the rail.
    tooltip: 'block w-full',

    // -- bottom slot: brand ------------------------------------------------
    brand: 'flex shrink-0 items-center justify-center border-t border-white/10 px-3 py-4',
    brandMark: 'h-8 w-8 shrink-0',
    brandLabel: 'ml-2 text-sm font-semibold text-primary-foreground',
};

export default Style;
